module.exports = __webpack_public_path__ + "img/img2.d32cb2c2.jpg";